<template>
  <div>
    <section :style="{ backgroundImage: 'url(' + require('@/assets/background_azul.png') + ')' }">
      <div class="container">
        <div class="row pt-4 pb-4">
          <div class="col-md-12">
            <img :src="require('@/assets/banner2.png')" class="img-fluid" />
          </div>
        </div>
      </div>
    </section>
    <section style="background-color: #e6e6e6;">
      <div class="container">
        <div class="row pt-5 pb-5">
          <div class="col-md-6">
            <p>O objetivo desta conferencia é que através de uma fonte oficial e reconhecida pelo ICC, os participantes aprendam com este tema e com uma forte ênfase local e internacional, assim como as novas regras e os diferenciais em relação as versões anteriores.</p>
            <p>Os participantes terão a oportunidade de responder as perguntas, entender a aplicação comercial para as vendas internacionais e obter uma visão mais completa, real e objetiva do aprendizado correto do Incoterms 2020.</p>
          </div>
          <div class="col-md-6">
            <button
              type="button"
              class="btn btn-primary btn-lg btn-block"
              style="background-color: #0033a0 !important; color: #fff; font-weight: bold; border: 0;"
              @click="$router.push({name: 'eventopt'})"
            >FAZER LOGIN PARA O EVENTO</button>
            <br />
            <h5 class="text-center">Data: Outubro 10 de 2019 ás 10h. Horário do Brasil.</h5>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="container">
        <div class="row mt-4">
          <div class="col-md-6">
            <img :src="require('@/assets/icono1.png')" class="img-fluid" style="height: 80px;" />
            <h2 class="blue-heading mt-3">VOLTDO PARA</h2>
            <p>Empresários; gerentes comerciais, financeiros, logísticos, de compras; diretores de comércio exterior; exportadores e importadores; consultores de comércio e negócios internacionais; funcionários de entidades públicas e privadas; e outros profissionais em áreas que precisam ser atualizadas nos costumes, tal e quanto tal, relacionados à entrega de mercadorias com o lncoterms® 2020.</p>
            <h2 class="blue-heading mt-3">CAGA HORÁRIA</h2>
            <p>4 horas</p>
          </div>
          <div class="col-md-6">
            <img :src="require('@/assets/icono2.png')" class="img-fluid" style="height: 80px;" />
            <h2 class="blue-heading mt-3">MÉTODO</h2>
            <p>A metodologia está orientada ao longo dos objetivos determinados e está confirmado por:</p>
            <p>
              <span class="blue-text">Fundamentação teórica:</span> os baseamentos são ensinados através de uma metodologia chamada "Inner structure", que facilita a navegada pelas obrigações A1-A10, B1-B10.
            </p>
            <p>
              <span class="blue-text">Participação:</span>  dos assistentes, por meio de comentários críticos e pela discussão de suas próprias experiências, relacionadas com os tópicos tratados e incentivada ao longo do curso. 
            </p>
          </div>
        </div>
      </div>
    </section>
    <section style="background-color: #e6e6e6;">
      <div class="container">
        <div class="row pt-5 pb-5">
          <div class="col-md-6">
            <h2 class="blue-heading mt-3 mb-0 text-right">OBJETIVO</h2>
            <h2 class="blue-heading mt-0 text-right">GERAIS</h2>
          </div>
          <div class="col-md-6">
            <ul>
              <li>Mergulhar nas novas terminologias.</li>
              <li>Aprender a estrutura de regras A1-A10,B1-B10 e fazer o uso eficiente do texto oficial.</li>
              <li>Compreender as regras Incoterms 2020 e as obrigações das partes (Clausulado A e B).</li>
            </ul>
          </div>
        </div>
        <hr style="background-color: #00b4e5; height: 5px;" />
        <div class="row pt-5 pb-5">
          <div class="col-md-6">
            <h2 class="blue-heading mt-3 mb-0 text-right">OBJETIVO</h2>
            <h2 class="blue-heading mt-0 text-right">ESPECÍFICOS</h2>
          </div>
          <div class="col-md-6">
            <ul>
              <li>Estabelecer uma visão geral do Incoterms 2020.</li>
              <li>Compreender as regras Incoterms 2020 no contexto histórico e atual.</li>
              <li>Distinguir a troca sobre diferentes versões.</li>
              <li>Aprender e conciliar as necessidades de cada função ( comprador – vendedor) com as regras do Incoterms 2020.</li>
              <li>Aplicar contrato de compra e venda.</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="container">
      <div class="row mt-4">
        <div class="col-md-6">
          <ul class="text-center" style="list-style: none; float: right;">
            <li style="display: inline-block;">
              <img :src="require('@/assets/icono3.png')" class="img-fluid" style="height: 80px;" />
            </li>
            <li style="display: inline-block;">
              <h2 class="blue-heading pl-3">CONTEÚDO</h2>
            </li>
          </ul>
        </div>

        <div class="col-md-6">
          <ol>
            <li>A ICC como organização generadora de instrumentos de comércio e Incoterms®</li>
            <li>Historia do Incoterms®</li>
            <li>Incoterms® para usuários. O que todo empresário deve saber. Apagando mitos.</li>
            <li>Falhas frequentes no uso do Icoterms®</li>
            <li>Mudanças oficiais no Incoterms® 2020</li>
            <li>Dicas de orientação no Incoterms® 2020</li>
            <li>Incoterms (2010) e Incoterms® (2020). Transição de obrigações A1- A10,B1-B10</li>
            <li>O seguro e as vendas repetitivas “String Sales” no Incoterms® 2020</li>
          </ol>
        </div>
      </div>
    </section>
    <section style="background-color: #e6e6e6;">
      <div class="container">
        <div class="row pt-5 pb-5">
          <div class="col-md-5">
            <img :src="require('@/assets/expositor.png')" class="img-fluid" style="height: 550px;" />
            <h2 class="blue-heading mt-3 mb-0">JUAN DIEGO</h2>
            <h2 class="blue-heading">ALZATE GÓMEZ</h2>
          </div>
          <div class="col-md-7">
            <p>Membro das comissões de Direito e Facilitação Comercial e Aduaneira e Práticas da ICC Colômbia, além de coordenador e formador do "Train The Trainer" da International Chamber of Commerce- Comitê Nacional da Colômbia e colaborador de vários comitês da América Latina. Foi Accredited Trainer no Incoterms®2010 da ICC.</p>
            <p>Perito em Negócios Internacionais, Supply Chain Management (SCMC®). Palestrante e formador em Assuntos Comerciais Internacionais, Marqueteiros e, Planejamento Estratégico. Professor de pós-graduação nos diferentes países da América Latina e membro de vários conselhos de administração. Palestrante Internacional, Diretor Geral da Megatransport Projects Logistics.</p>
            <p>Em 2011, ele fundou a empresa Maximum Consulting, dedicada ao Direito Internacional dos Negócios, Estratégia e na "Supply Chain".</p>
            <p>Atualmente, ele é doutorando em "Business Administration" pela Maastricht School of Management, na Netherlands, e doutorado em "Administração Estratégica" pela CENTRUM Graduate Business School. Ele é "MBA" pela EADA Business School na Espanha e é "Mestrado em Negócios Globais" pela Universidade Católica do Peru. Tem outro Mestrado em Filosofia pela Maastritch School of Management e "Marketing Management Specialist" pela Universidade Externado da Colômbia.</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  props: ["lang"],
  name: "infopt",
  data() {
    return {};
  },
};
</script>
<style scoped>
.blue-text,
.blue-heading {
  color: #0033a0;
  font-weight: bold;
}

p {
  color: #000;
  font-family: "Open Sans", sans-serif;
}

label {
  color: #fff;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
}

.text-danger {
  text-shadow: 1px 1px #000;
}

.barco {
  border: 20px solid #fff;
  -webkit-box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.75);
}

#sura-logo {
  height: 80px;
}

#logo {
  height: 80px;
  display: block;
  margin: 0 auto;
}
</style>
